<template>
    <a :target="target" :href="href" v-html="innerHtml" @click="saveClick"/>
</template>

<script>
    import setInputValue from "../utils/setInputValue";

    export default {
        props: {
            target: {default: ''},
            href: {default: ''},
            saveTo: {},
            innerHtml: {}
        },
        data() {
            return {
                content: 'children content',
                clicks: 0
            }
        },
        computed: {},
        mounted() {
            setInputValue(this.saveTo, 0);
        },
        methods: {
            saveClick() {
                this.clicks++;
                setInputValue(this.saveTo, this.clicks);
            }
        },
        watch: {},
        components: {}
    }
</script>
